import { render, staticRenderFns } from "./ServidorMargem.vue?vue&type=template&id=3a06e16e&"
import script from "./ServidorMargem.vue?vue&type=script&lang=js&"
export * from "./ServidorMargem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports